import { Row, Col, Breadcrumb } from "react-bootstrap";

const EowBreadCrumbs = () => {
  return (
    <Row>
      <Col xs="12">
        <Breadcrumb className="leap">
          <Breadcrumb.Item href="/endofwaste">
            End-of-waste Register Home
          </Breadcrumb.Item>
        </Breadcrumb>
      </Col>
    </Row>
  );
};

export default EowBreadCrumbs;
